export default "/images/vendor/@coreui/icons/svg/flag/cif-hk.svg?9873f49763d4e5ad473df3004c76e656";